import { createAction, props } from '@ngrx/store';
import { AttemptStudentData } from './modal-audit.state';

export const InitDataEffect = createAction('[ModalAudit] InitDataEffect', props<ModalAuditData>());
export const RemoveAttemptEffect = createAction('[ModalAudit] RemoveAttemptEffect', props<{ attempt_uuid: string }>());
export const UpdateQuestionScoreEffect = createAction(
  '[ModalAudit] UpdateQuestionScoreEffect',
  props<UpdateQuestionScoreData>(),
);
export const UpdateStudentRandModeEffect = createAction(
  '[ModalAudit] UpdateStudentRandModeEffect',
  props<{ attempt_uuid: string; rand_mode: number }>(),
);

export const RefreshQuestionsRandModeEffect = createAction(
  '[ModalAudit] RefreshQuestionsRandModeEffect',
  props<{ rand_mode: number }>(),
);

export const AssingStudentEffect = createAction(
  '[ModalAudit] AssingStudentEffect',
  props<{ attempt_uuid: string; student: AttemptStudentData }>(),
);

export const UpdateStudentAllBlankEffect = createAction(
  '[ModalAudit] UpdateStudentAllBlankEffect',
  props<{ application_uuid: string; attempt_uuid: string; user_id: number; rand_mode: number }>(),
);

export const ClearStageReducer = createAction('[ModalAudit] ClearStageReducer');
export const DataLoadedReducer = createAction('[ModalAudit] DataLoadedReducer', props<DataLoadedData>());
export const UpdateAttemptQuestionReducer = createAction('[ModalAudit] UpdateAttemptQuestionReducer', props<any>());
export const RemoveAttemptReducer = createAction(
  '[ModalAudit] RemoveAttemptReducer',
  props<{ attempt_uuid: string }>(),
);
export const UpdateRandModeReducer = createAction(
  '[ModalAudit] UpdateRandModeReducer',
  props<{ attempt: any; rand_mode: number }>(),
);

export const AssignStudentReducer = createAction(
  '[ModalAudit] AssignStudentReducer',
  props<{ attempt_uuid: string; student: AttemptStudentData }>(),
);

export const UpdateStudentActiveReducer = createAction(
  '[ModalAudit] UpdateStudentActiveReducer',
  props<{ user_id: number; attempt_uuid?: string }>(),
);
export const UpdateQuestionActiveReducer = createAction(
  '[ModalAudit] UpdateQuestionActiveReducer',
  props<{ question_uuid: string }>(),
);

export const QuestionLoadingReducer = createAction(
  '[ModalAudit] QuestionLoadingReducer',
  props<{ question_uuid: string; loading: boolean }>(),
);

export const StudentLoadingReducer = createAction(
  '[ModalAudit] StudentLoadingReducer',
  props<{ attempt_uuid: string; user_id: number; loading: boolean }>(),
);

export const RefreshQuestionsRandModeReducer = createAction(
  '[ModalAudit] RefreshQuestionsRandModeReducer',
  props<{ rand_mode: number; questions: any[] }>(),
);

export interface ModalAuditData {
  entity_id: number;
  application_uuid: string;
  user_id: number;
}

interface DataLoadedData {
  application: any;
  students: AttemptStudentData[];
  user_id: number;
}

interface UpdateQuestionScoreData {
  application_uuid: string;
  user_id: number;
  attempt_uuid: string;
  question_uuid: string;
  rand_mode: number;
  alternative_uuid?: string;
  score?: number;
  is_blank?: number;
  feedback?: string;
}
